import {
  grpc,
  UI,
  DevToolsRpcMiddleware,
  ErrorMiddleware,
} from '@skedulo/protobuf-web'
import { FetchApiClient } from '../fetch-api-client'
import {
  ActionUiApiClientV1,
  FilterUiApiClientV1,
  ListUiApiClientV1,
  NavUiApiClientV1,
  PageUiApiClientV1,
  PageTemplateUiApiClientV1,
  ResourceUiApiClientV1,
  TemplateUiApiClientV1,
  ValidationUiApiClientV1,
  ViewOverrideUiApiClientV1,
} from './services'
import type {
  IApiClientWithSessionOptions,
  IExecuteBulkActionRequest,
  IExecuteBulkActionResponse,
  IInitiateSchemaSyncRequest,
  IInitiateSchemaSyncResponse,
} from '../../types'

export class UiApiClientV1 {
  /** @deprecated Use the typed UiApiClientV1 methods instead. */
  readonly client: UI.API.Client
  private readonly grpcClient: UI.API.Client
  private readonly metadata: grpc.Metadata
  private readonly restClient: FetchApiClient

  readonly filter: FilterUiApiClientV1
  readonly nav: NavUiApiClientV1
  readonly list: ListUiApiClientV1
  readonly resource: ResourceUiApiClientV1
  readonly template: TemplateUiApiClientV1
  readonly validation: ValidationUiApiClientV1
  readonly viewOverride: ViewOverrideUiApiClientV1
  readonly page: PageUiApiClientV1
  readonly pageTemplate: PageTemplateUiApiClientV1
  readonly actions: ActionUiApiClientV1

  constructor(
    { platformApiDomain, metadata, session }: IApiClientWithSessionOptions,
    uiApiRestClient: FetchApiClient,
  ) {
    // gRPC client retained for actions (getAction/getActionsList) and initiateSchemaSync
    this.grpcClient = new UI.API.Client(
      new ErrorMiddleware(
        new DevToolsRpcMiddleware(
          new UI.API.RPC(platformApiDomain, { metadata }),
        ),
      ),
    )
    this.client = this.grpcClient
    this.metadata = metadata
    this.restClient = uiApiRestClient

    const restOpts = { restClient: uiApiRestClient, session }

    this.filter = new FilterUiApiClientV1(restOpts)
    this.nav = new NavUiApiClientV1(restOpts)
    this.list = new ListUiApiClientV1(restOpts)
    this.resource = new ResourceUiApiClientV1(restOpts)
    this.template = new TemplateUiApiClientV1(restOpts)
    this.validation = new ValidationUiApiClientV1(restOpts)
    this.viewOverride = new ViewOverrideUiApiClientV1(restOpts)
    this.page = new PageUiApiClientV1(restOpts)
    this.pageTemplate = new PageTemplateUiApiClientV1(restOpts)
    this.actions = new ActionUiApiClientV1(
      {
        client: this.grpcClient,
        metadata,
        session,
      },
      uiApiRestClient,
    )
  }

  public async initiateSchemaSync(
    request: IInitiateSchemaSyncRequest,
  ): Promise<IInitiateSchemaSyncResponse> {
    return this.grpcClient.initiateSchemaSync(request, this.metadata)
  }

  public async executeBulkAction(
    request: IExecuteBulkActionRequest,
  ): Promise<IExecuteBulkActionResponse> {
    return this.restClient.post<IExecuteBulkActionResponse>(
      '/v1/bulk-actions/execute',
      {
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request),
      },
    )
  }
}
